import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  containerMain: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    paddingBottom: '8px'
  },
  formAbout: {
    display: 'flex',
    gap: '16px'
  },
  containerTitle: {
    display: 'flex',
    gap: '16px'
  }
}));
